import { query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { LocalData } from "../../../to-be-removed/LocalData/General/LocalData";
import { CollectionData } from "../../../to-be-removed/LocalData/collections/CollectionData";
import { CollectionFieldData } from "../../../to-be-removed/LocalData/collections/CollectionFieldData";

export const useCollectionFields = (collection: CollectionData | undefined) => {
  const [customFields, setCustomFields] = useState<CollectionFieldData[]>([]);

  useEffect(() => {
    if (!collection) return;
    const unsubscribe = LocalData.collectionFields.setupRealtimeListenerWithFilter(
      (ref) => query(ref, where("collectionID", "==", collection.id)),
      (data) => {
        setCustomFields(data);
      }
    );

    return () => unsubscribe.removeListener();
  }, [collection]);

  return customFields;
};
